export default {
  loading(state, payload) {
    state.loading = payload;
  },
  login(state, payload) {
    state.isLogin = true;
    state.countInfo = payload;
  },
  loginOut(state, payload) {
    state.isLogin = false;
  },
  // 改变是否打印小票
  changeReceipt(state, payload) {
    state.printConfig.isReceipt = payload;
  },
  // 收费清单打印机
  changeMedicine(state, payload) {
    state.printConfig.medicineValue = payload;
  },
  changeScript(state, payload) {
    state.printConfig.scriptValue = payload;
  },
  changeOther(state, payload) {
    state.printConfig.otherValue = payload;
  },
  changeInfusion(state, payload) {
    state.printConfig.infusionValue = payload;
  },
  changeRecord(state, payload) {
    state.printConfig.medicalRecordValue = payload;
  },
  setWindowHeight(state, payload) {
    state.windowHeight = payload;
  },
};
